export interface ColliderMeta {
  id: string
  name: string
  sourceTag?: string
  category?: 'wall' | 'door' | 'destructible' | 'elevator' | 'floor' | 'ceiling' | 'target' | 'pillar' | 'trim' | 'enemy'
}

export class ColliderRegistry {
  private static instance: ColliderRegistry
  private readonly metadata = new Map<number, ColliderMeta>()

  static getInstance(): ColliderRegistry {
    if (!ColliderRegistry.instance) {
      ColliderRegistry.instance = new ColliderRegistry()
    }
    return ColliderRegistry.instance
  }

  register(handle: number, meta: ColliderMeta): void {
    this.metadata.set(handle, meta)
  }

  get(handle: number): ColliderMeta | undefined {
    return this.metadata.get(handle)
  }

  deregister(handle: number): void {
    this.metadata.delete(handle)
  }

  clear(): void {
    this.metadata.clear()
  }
}

export const colliderRegistry = ColliderRegistry.getInstance()
